const { __ } = wp.i18n;
const { PanelBody, PanelRow, FormToggle } = wp.components;
const BControls = ({ attributes: { options }, updateOption }) => {
  const { controls } = options;
  const controlSettings = [
    {
      label: "Play Large",
      control: "play-large",
    },
    {
      label: "Restart",
      control: "restart",
    },
    {
      label: "Rewind",
      control: "rewind",
    },
    {
      label: "Play",
      control: "play",
    },
    {
      label: "Fast Forward",
      control: "fast-forward",
    },
    {
      label: "Progress",
      control: "progress",
    },
    {
      label: "Current Time",
      control: "current-time",
    },
    {
      label: "Duration",
      control: "duration",
    },
    {
      label: "Mute",
      control: "mute",
    },
    {
      label: "Volume",
      control: "volume",
    },
    {
      label: "PIP",
      control: "pip",
    },
    {
      label: "Airplay",
      control: "airplay",
    },
    {
      label: "Captions",
      control: "captions",
    },
    {
      label: "Settings",
      control: "settings",
    },
    {
      label: "Download",
      control: "download",
    },
    {
      label: "Fullscreen",
      control: "fullscreen",
    },
  ];
  const handleControl = (control) => {
    const originalControls = controlSettings.map((item) => item.control);
    let newControls;
    if (controls.includes(control)) {
      newControls = controls.filter((item) => item !== control);
    } else {
      newControls = originalControls.filter((item) => {
        if (controls.includes(item) || item === control) {
          return true;
        }
      });
    }
    updateOption({ controls: newControls });
  };
  return (
    <PanelBody>
      {controlSettings.map(({ label, control }) => {
        return (
          <PanelRow key={control}>
            <label htmlFor={control} className="label">
              {__(label, "h5vp")}
            </label>
            <FormToggle id={control} checked={controls.includes(control)} onChange={() => handleControl(control)} />
          </PanelRow>
        );
      })}
    </PanelBody>
  );
};

export default BControls;
